import {clear} from '../../redux/actions/ui/dataImport/index.js'

import DataImportFilter from './DataImportFilter.js'
import FileUpload from './FileUpload.js'
import Overview from './Overview.js'
import {
  clearDataImport,
  dataImport2Selector,
  dataImportSelector,
  debounceComputeErrors,
} from './dataImportFunctions.js'
import {dispatch, useSelector} from '../../store.js'
import ColumnMappings from './ColumnMappings.js'
import ButtonLink from '../../common/components/Button/ButtonLink.js'
import {useEffect, useMemo} from 'react'
import ImportHistory from './ImportHistory.js'

export default function Header({
  importOptions,
  processFiles,
  createExampleFile,
  confirmColumns,
  saveAll,
  queueNextData,
  stop,
  columnOptions,
  type,
}) {
  const columns = useSelector(dataImportSelector).columns
  const {
    columns: columnsV2,
    rows,
    columnImportList,
  } = useSelector(dataImport2Selector)

  const options = useMemo(() => {
    const list = []

    if (!columnImportList) {
      return list
    }

    for (const option of columnOptions) {
      const count = columnImportList.filter((v) => option.value === v).length

      list.push({
        ...option,
        missing: count === 0,
        duplicated: count > 1,
      })
    }

    return list
  }, [columnOptions, columnImportList])

  const hasColumns = columns.length !== 0
  const hasColumnsV2 = !!columnsV2?.length
  const needsColumnMappingsValidated = hasColumnsV2
  const canReset = hasColumnsV2

  useEffect(() => {
    debounceComputeErrors(options)
  }, [rows, columnImportList])

  return (
    <div className="meta-csv-div-header margin-top-20">
      <div className="row">
        <div className="medium-8 medium-centered align-center columns">
          <h2 className="list-title align-center margin-bottom-10">
            <span>Data Import</span>
          </h2>
          {canReset ? (
            <ButtonLink
              className="fs-n0 margin-bottom-15"
              onClick={clearDataImport}
            >
              Restart
            </ButtonLink>
          ) : (
            hasColumns && (
              <button
                type="button"
                className="btn btn--link fs-n0 margin-bottom-15"
                onClick={() => dispatch(clear())}
              >
                Restart
              </button>
            )
          )}
        </div>
      </div>
      {needsColumnMappingsValidated ? (
        <ColumnMappings columnOptions={options} />
      ) : hasColumns ? (
        <Overview
          confirmColumns={confirmColumns}
          saveAll={saveAll}
          queueNextData={queueNextData}
          stop={stop}
        />
      ) : (
        <div className="row margin-top-20">
          <div className="medium-8 medium-centered columns">
            <DataImportFilter importOptions={importOptions} />
            <FileUpload onFiles={processFiles} />
            <p className="centered-text">
              <button
                className="create-example-file inline-text-button make-smaller margin-bottom-0 meta-csv-button-downloadexample"
                onClick={createExampleFile}
              >
                Download an example file
              </button>
            </p>
            {type && <ImportHistory type={type} />}
          </div>
        </div>
      )}
    </div>
  )
}
